module.exports = __webpack_public_path__ + "img/k-pink-woman-back.8d2ef42d.jpg";